export const CUSTOMER_TYPES = {
    INDIVIDUAL: "INDIVIDUAL",
    CORPORATION: "CORPORATION"
};

export const ACCOUNT_STATUSES = {
    CREATED: "CREATED",
    ACTIVE: "ACTIVE",
    DEACTIVATED: "DEACTIVATED",
    DELETED: "DELETED"
};

export const ACCOUNT_STATUS_OPTIONS = [
    { value: ACCOUNT_STATUSES.CREATED, label: "Créé" },
    { value: ACCOUNT_STATUSES.ACTIVE, label: "Actif" },
    { value: ACCOUNT_STATUSES.DEACTIVATED, label: "Désactivé" },
    { value: ACCOUNT_STATUSES.DELETED, label: "Supprimé" }
];

export const EMPTY_PHONE = {
    phoneNumber: "",
    label: ""
};

export function createEmptyProfile() {
    return {
        username: "",
        firstName: "",
        lastName: "",
        customerType: CUSTOMER_TYPES.INDIVIDUAL,
        photoId: null,
        companyName: "",
        registrationNumber: "",
        taxId: "",
        email: "",
        phones: [{ ...EMPTY_PHONE }]
    };
}

export function customerDisplayName(profile) {
    if (!profile) {
        return "";
    }
    if (profile.customerType === CUSTOMER_TYPES.CORPORATION && profile.companyName?.trim()) {
        return profile.companyName.trim();
    }
    return `${profile.firstName || ""} ${profile.lastName || ""}`.trim();
}

export function normalizePhones(phones) {
    if (!phones?.length) {
        return [{ ...EMPTY_PHONE }];
    }
    return phones.map((phone) => ({
        phoneNumber: phone.phoneNumber || "",
        label: phone.label || ""
    }));
}

export function formatCustomerType(customerType) {
    if (customerType === CUSTOMER_TYPES.CORPORATION) {
        return "Entreprise";
    }
    return "Particulier";
}

export function formatAccountStatus(accountStatus) {
    const labels = {
        [ACCOUNT_STATUSES.CREATED]: "Créé",
        [ACCOUNT_STATUSES.ACTIVE]: "Actif",
        [ACCOUNT_STATUSES.DEACTIVATED]: "Désactivé",
        [ACCOUNT_STATUSES.DELETED]: "Supprimé"
    };
    return labels[accountStatus] || accountStatus || "—";
}
